import { initContract } from "@ts-rest/core";
import { z } from "zod";
import {
    getOpeningBalanceResponseSchema,
    getOpeningBalancesResponseSchema,
    getUnreconciledKickBalancesResponseSchema,
    openingBalanceLedgerBasisQuerySchema,
    setOpeningBalancesBulkBodySchema,
    upsertOpeningBalanceBodySchema,
} from "@common/schemas/domains/accounting/opening-balance.schema";
import { entityIdsQuerySchema } from "@common/schemas/entity-ids-query.schema";
import { ErrorMessageSchema } from "@common/schemas/error.schema";

const c = initContract();

const entityPathParams = z.object({ entityId: z.coerce.number() });
const workspacePathParams = z.object({ workspaceId: z.string().uuid() });
const accountPathParams = z.object({
    entityId: z.coerce.number(),
    accountId: z.string().uuid(),
});

export const openingBalanceContract = c.router(
    {
        getOpeningBalances: {
            method: "GET",
            path: "/:entityId",
            pathParams: entityPathParams,
            query: openingBalanceLedgerBasisQuerySchema,
            responses: {
                200: getOpeningBalancesResponseSchema,
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        setOpeningBalancesBulk: {
            method: "POST",
            path: "/:entityId/bulk",
            pathParams: entityPathParams,
            query: openingBalanceLedgerBasisQuerySchema,
            responses: {
                201: z.void(),
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
            body: setOpeningBalancesBulkBodySchema,
        },
        getUnreconciledKickBalances: {
            method: "GET",
            path: "/:entityId/unreconciled-kick-balances",
            pathParams: entityPathParams,
            responses: {
                200: getUnreconciledKickBalancesResponseSchema,
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        getUnreconciledKickBalancesForEntities: {
            method: "GET",
            path: "/workspace/:workspaceId/unreconciled-kick-balances",
            pathParams: workspacePathParams,
            query: z.object({
                entityIds: entityIdsQuerySchema,
            }),
            responses: {
                200: getUnreconciledKickBalancesResponseSchema,
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        getOpeningBalance: {
            method: "GET",
            path: "/:entityId/:accountId",
            pathParams: accountPathParams,
            query: openingBalanceLedgerBasisQuerySchema,
            responses: {
                200: getOpeningBalanceResponseSchema,
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        upsertOpeningBalance: {
            method: "POST",
            path: "/:entityId/:accountId",
            pathParams: accountPathParams,
            query: openingBalanceLedgerBasisQuerySchema,
            responses: {
                200: getOpeningBalanceResponseSchema,
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
            body: upsertOpeningBalanceBodySchema,
        },
        removeOpeningBalance: {
            method: "DELETE",
            path: "/:entityId/:accountId",
            pathParams: accountPathParams,
            query: openingBalanceLedgerBasisQuerySchema,
            body: null,
            responses: {
                200: z.void(),
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    { pathPrefix: "/accounting/opening-balance" },
);
